import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const ProtectedRoute = ({ children, roles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8" data-testid="unauthorized-message">
        <div className="max-w-md text-center bg-white rounded-xl border border-slate-200 p-8 shadow-sm">
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Manrope', color: '#B91C1C' }}>Access Denied</h1>
          <p className="text-slate-600 text-sm">You don't have permission to access this page. Your role ({user.role}) is not allowed here.</p>
        </div>
      </div>
    );
  }

  return children;
};